import "./App.css";
import "./css/Global Css/globalCss.css";
import Dashboard from "./component/Dashboard/Dashboard";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import LoginNew from "./component/Login/LoginNew"
import { ProtectedRoutes } from "./ProtectedRoutes";
import PosReaderPreview from "./component/Modules/PointOfSale/posReaderPreview/PosReaderPreview";

import SuccessSnackbar from "./component/Single Components/SnackBars/SuccessSnackbar";
import ErrorSnackbar from "./component/Single Components/SnackBars/ErrorSnackbar";
import { LoadingForm } from "./component/Single Components/LoadingForm";
import { useSelector } from "react-redux";
import store from "./Redux/store";
import { setErrorSnack, setSuccessSnack } from "./component/Modules/Sales/Billing/Slice/billingScreenSlice";
import PublicJobOffer from "./component/Public/JobOffer/PublicJobOffer";
import CampaignLandingPage from "./component/Public/CampaignLandingPage";
import PublicFormView from "./component/Public/PublicFormView";
import PublicStorePage from './component/Public/PublicStorePage';
import PublicStorePageNew from './component/Public/PublicStorePageNew';
import PublicStorePageEnhanced from './component/Public/PublicStorePageEnhanced';
import OrderTrackingPage from './component/Public/OrderTrackingPage';
import CustomerOrderList from './component/Public/CustomerOrderList';

// Import offline sync status indicator
import { SyncStatusIndicator } from './offline';

const ConditionalSyncStatusIndicator = () => {
  const location = useLocation();
  const path = location?.pathname || "";
  const hideOnTokenDisplay = path.includes("/userdashboard/tokenDisplay");
  if (hideOnTokenDisplay) return null;
  return <SyncStatusIndicator position="top-right" showDetails={true} />;
};

function App() {
  const { successSnack, errorSnack, snackMsg } = useSelector(
    (state) => state.billingScreenSlice
  );
  const { submitLoading } = useSelector((state) => state.mainDashBoardSlice);
  
  const handleClose=()=>{
    store.dispatch(setSuccessSnack(false))
    store.dispatch(setErrorSnack(false))
  }
  return (
    <div className="App">
      <BrowserRouter>
        {/* Offline Sync Status Indicator */}
        <ConditionalSyncStatusIndicator />
        <Routes>
          {/* <Route exact path="/" element={<Login />} /> */}
          <Route exact path="/" element={<LoginNew />} />
          <Route path="posReaderPreview/*" element={<PosReaderPreview />} />
          <Route path="career/offer/:token" element={<PublicJobOffer />} />
          <Route path="c/:shortCode" element={<CampaignLandingPage />} />
          <Route path="store/:storeSlug/orders" element={<CustomerOrderList />} />
          <Route path="store/:storeSlug/track/:orderId" element={<OrderTrackingPage />} />
          <Route path="store/:storeSlug" element={<PublicStorePageEnhanced />} />
          <Route path=":storeSlug" element={<PublicStorePageEnhanced />} />
          <Route path="form/:db/:formId" element={<PublicFormView />} />
          <Route path="form/:formId" element={<PublicFormView />} />
          <Route element={<ProtectedRoutes />}>
            <Route path="userdashboard/*" element={<Dashboard />} />
          </Route>
        </Routes>
      </BrowserRouter>


      <SuccessSnackbar
        open={successSnack}
        handleClose={handleClose}
        message={snackMsg}
      />
      <ErrorSnackbar
        open={errorSnack}
        handleClose={handleClose}
        message={snackMsg}
      />
      <LoadingForm loading={submitLoading} />
    </div>
  );
}

export default App;
